import { Favorite } from '@mui/icons-material';
import { useState } from 'react';
import usePropertyRequestsStore from 'store/propertyRequestsStore';
import { PropertyLead } from 'types/PropertyLead';
import { formatDateForPropertyRequests } from 'util/formatDate';
import OpenRequestDetailsModal from './OpenRequestDetailsModal';

export default function OpenRequestCard({ lead }: { lead: PropertyLead }) {
    const [isOpen, setIsOpen] = useState(false);
    const { setSelectedLead } = usePropertyRequestsStore();

    return (
        <>
            <div className=" bg-white rounded-xl border border-gray-200 font-poppins">
                <div className="p-6 space-y-4">
                    {/* Header */}
                    <div className="flex items-center space-x-3 text-sm">
                        <span className="text-my-blue p-1 bg-my-blue bg-opacity-5 rounded">REQ-{lead.id.substring(0, 6)}</span>
                        <span className="text-my-black/60">Posted {formatDateForPropertyRequests(lead?.createdAt)}</span>
                    </div>

                    {/* Title */}
                    <h2 className="text-lg font-semibold text-my-black/80">{lead.title}</h2>

                    {/* Description */}
                    <p className="text-my-black/60 text-base font-normal">{lead.description}</p>

                    <div className="flex flex-wrap gap-2 pt-2">
                        {[
                            lead.propertyType,
                            lead.definedArea ? lead.definedArea : lead.cities.map((city) => city.city).join(', '),
                            lead.propertyNeighborhood && lead.propertyNeighborhood.length > 0 ? lead.propertyNeighborhood.join(', ') : null,
                            `€${lead.minBudget} - €${lead.maxBudget}`,
                            lead.minConstructionArea && lead.maxConstructionArea ? `${lead.minConstructionArea} - ${lead.maxConstructionArea} m²` : null,
                            lead.minPlotArea && lead.maxPlotArea ? `${lead.minPlotArea} - ${lead.maxPlotArea} m²` : null,
                        ]
                            .filter(Boolean)
                            .map((item, index) => (
                                <span key={index} className="px-3 py-1 bg-white/50 border rounded text-sm text-my-black/70">
                                    {item}
                                </span>
                            ))}
                    </div>
                </div>

                {/* Footer */}
                <div className="border-t border-gray-100">
                    <div className="px-6 py-3 flex justify-between items-center bg-my-gray/20">
                        <div className="flex items-center space-x-2">
                            <Favorite className="text-my-green" />
                            <span className="text-sm font-medium text-my-black/80">
                                Saved by <span className="font-semibold">{lead.savedCount}</span> agents
                            </span>
                        </div>
                        <div className=" bg-white border border-gray-200 rounded-lg ">
                            <button
                                className="text-sm font-semibold py-2.5 px-4 text-my-black/70 hover:text-gray-900"
                                onClick={() => {
                                    setSelectedLead(lead);
                                    setIsOpen(true);
                                }}
                            >
                                More Details
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <OpenRequestDetailsModal isOpen={isOpen} setIsOpen={setIsOpen} />
        </>
    );
}
